export default __webpack_public_path__ + "5e493812deabd1d01e6019ad87e77986.woff2";